import moment from 'moment'
import cloneDeep from 'lodash/cloneDeep'
import {
  logClickTile,
  logGetAirlineAndFB,
} from '../../../../client/common/log-ga-event'

const airporFilterAndMap = (
  airports,
  updateAirportsFiltersUI,
  delayedStateUpdate,
  entity
) => {
  return airports
    .filter(airport => airport.checked === true && airport.disabled === false)
    .map(airport => {
      const _airport = cloneDeep(airport)
      _airport.onClick = () => {
        const changed = [_airport.value, false]
        updateAirportsFiltersUI(changed, {}, entity)
        delayedStateUpdate(changed, 'AIRPORT')
      }

      _airport.primaryLabel = `${
        entity === 'origin' ? 'Departing from' : 'Traveling to'
      } ${_airport.value}`
      return _airport
    })
}

export const buildListingsFilterProps = ({
  airlinesFilter,
  stopsFilter,
  airportsFilter,
  altDatesFilter,
  timeFilter,
  attributesFilter,
  filterDefaults,
  updateStopsFiltersUI,
  updateAirlineFiltersUI,
  updateAirportsFiltersUI,
  delayedStateUpdate,
  updateExactDateFiltersUI,
  resetTimeFilters,
  updateTimeFilters,
  updateAttributesFiltersUI,
}) => {
  let props = []
  if (airlinesFilter) {
    props = props.concat(
      airlinesFilter
        .filter(airline => airline.checked === true)
        .map(airline => {
          airline.onClick = () => {
            const payload = { value: airline.value, checked: false }
            updateAirlineFiltersUI(payload)
            delayedStateUpdate(payload, 'AIRLINE')
          }
          return airline
        })
    )
  }

  if (attributesFilter?.length) {
    props = props.concat(
      attributesFilter
        .filter(attribute => attribute.checked === true)
        .map(attribute => {
          attribute.onClick = () => {
            const payload = { value: attribute.value, checked: false }
            updateAttributesFiltersUI({ payload })
            // delayedStateUpdate(payload, 'AIRLINE')
          }
          return attribute
        })
    )
  }

  if (stopsFilter && Array.isArray(stopsFilter)) {
    props = props.concat(
      stopsFilter
        .filter(stop => stop.checked === true)
        .map(stop => {
          stop.onClick = () => {
            const changed = { [stop?.value]: false }
            updateStopsFiltersUI(changed)
            delayedStateUpdate(changed, 'STOP')
          }
          return stop
        })
    )
  }

  if (airportsFilter && Array.isArray(airportsFilter)) {
    airportsFilter.forEach(airports => {
      props = props.concat(
        airporFilterAndMap(
          airports.originAirports,
          updateAirportsFiltersUI,
          delayedStateUpdate,
          'origin'
        )
      )
      props = props.concat(
        airporFilterAndMap(
          airports.destinationAirports,
          updateAirportsFiltersUI,
          delayedStateUpdate,
          'dest'
        )
      )
    })
  }

  if (timeFilter) {
    const {
      minTakeoffTime,
      maxTakeoffTime,
      minLandingTime,
      maxLandingTime,
      sliceDurationMax,
      sliceRefId,
    } = timeFilter

    if (minTakeoffTime || maxTakeoffTime) {
      const takeOff = {
        primaryLabel: `${formatTime(minTakeoffTime)} to ${formatTime(
          maxTakeoffTime
        )} takeoff`,
        value: 'takeoffTime',
        onClick: () => {
          updateTimeFilters(
            {
              min: filterDefaults?.TIME?.[0]?.minTakeoffTime,
              max: filterDefaults?.TIME?.[0]?.maxTakeoffTime,
            },
            'depart',
            sliceRefId
          )
        },
      }
      props.push(takeOff)
    }

    if (minLandingTime || maxLandingTime) {
      const landing = {
        primaryLabel: `${formatTime(minLandingTime)} to ${formatTime(
          maxLandingTime
        )} landing`,
        value: 'landingTime',
        onClick: () => {
          updateTimeFilters(
            {
              min: filterDefaults?.TIME?.[0]?.minLandingTime,
              max: filterDefaults?.TIME?.[0]?.maxLandingTime,
            },
            'arrive',
            sliceRefId
          )
        },
      }
      props.push(landing)
    }

    if (sliceDurationMax) {
      const duration = {
        primaryLabel: `${formatDuration(sliceDurationMax)} max duration`,
        value: 'maxDuration',
        onClick: () => {
          resetTimeFilters('duration')
          delayedStateUpdate(null, 'duration')
        },
      }
      props.push(duration)
    }
  }

  if (altDatesFilter && Array.isArray(altDatesFilter)) {
    props = props.concat(
      altDatesFilter
        .filter(altDate => altDate.checked === true)
        .map(altDate => {
          altDate.onClick = () => {
            const changed = [altDate?.value, false]
            updateExactDateFiltersUI(changed)
            delayedStateUpdate(changed, 'ALTDATES')
          }
          return altDate
        })
    )
  }

  return props
}

function formatTime(millisecond) {
  const momentNumber = moment.utc(millisecond)
  const meridian = momentNumber.hour() < 12 ? 'a' : 'p'

  return momentNumber.format(`ddd h:mm[${meridian}]`)
}

function formatDuration(minutes) {
  return `${Math.floor(minutes / 60)}h ${Number(minutes % 60)}m`
}

export const gaTagUpsellTileClick = (slotNum, FbName, airlineName) => {
  logGetAirlineAndFB(FbName, airlineName)
  const slot = `slot - ${slotNum + 1}`
  logClickTile(slot)
}
